<template>
  <Modal
    :value="value"
    v-on="$listeners"
    :title="item.chocoPackage.Title"
    :subtitle="`${item.chocoPackage.Id} - ${nameAndVersion.version}`"
  >
    <template slot="body" class="content">
      <Warnings :item="item"></Warnings>

      <div class="content content-padding" v-html="html"></div>
    </template>
    <template slot="footer" class="content">
      <div
        class="button is-primary"
        @click="
          $emit('input', false);
          $emit('openActions');
        "
      >
        Open actions
      </div>
      <div class="button" @click="$emit('input', false)">Close</div>
    </template>
  </Modal>
</template>

<script>
import showdown from "showdown";
import { getPackageNameVersionAndHash } from "@/utils/mdc";

export default {
  components: {
    Modal: () => import("./Modal"),
    Warnings: () => import("@/components/main/packages/Warnings.vue"),
  },
  props: ["value", "item"],
  data() {
    return {
      show: false,
      converter: null,
    };
  },
  computed: {
    nameAndVersion() {
      return getPackageNameVersionAndHash(this.item);
    },
    html() {
      return this.converter.makeHtml(this.item.chocoPackage.Description);
    },
  },
  created() {
    this.converter = new showdown.Converter();
  },
  methods: {},
};
</script>
